export class LoginAttempt {
  id: string;
  attempts: number = 1;

  constructor(loginAttempt: Partial<LoginAttempt>) {
    _.merge(this, loginAttempt);
  }

  static build(loginAttempt: Partial<LoginAttempt>): LoginAttempt {
    return new LoginAttempt(loginAttempt);
  }
}

angular.module('capability-ng-user-app').factory('ngLoginAttemptBuilder', function(): typeof LoginAttempt {
  return LoginAttempt;
});



// WEBPACK FOOTER //
// ./app/lib/user_app/builders/login_attempt_builder.ts